if (!customElements.get('animated-search-text')) {
  customElements.define(
    'animated-search-text',
    class AnimatedSearchText extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback () {
        this.cycle()
      }

      async typeText (sentence) {
        const textEl = this.querySelector('[data-animated-search-text-el="text"]')
        const text = sentence.split('')

        for (let i = 0; i < text.length; i++) {
          textEl.textContent += text[i]

          await this.delay(this.typeSpeed)
        }
      }

      async deleteText () {
        const textEl = this.querySelector('[data-animated-search-text-el="text"]')
        const text = textEl.textContent.split('')

        for (let i = text.length; i >= 0; i--) {
          textEl.textContent = textEl.textContent.slice(
            0,
            i,
          )
          await this.delay(this.deleteSpeed)
        }
      }

      async cycle () {
        const textEl = this.querySelector('[data-animated-search-text-el="text"]')
        const dataEl = this.querySelector('[data-animated-search-text-el="data"]')

        if (!dataEl) return

        const data = JSON.parse(dataEl.textContent)

        for (let i = 0; i < data.length; i++) {
          textEl.textContent = ''
          await this.typeText(data[i])
          await this.delay(this.deleteDelay)
          await this.deleteText()
          await this.delay(this.nextWordDelay)
        }

        this.cycle()
      }

      delay (ms) {
        const waitTimer = new Promise(resolve => setTimeout(resolve, ms))

        return waitTimer
      }

      get typeSpeed () {
        return this.dataset.typeSpeed
      }

      get deleteSpeed () {
        return this.dataset.deleteSpeed
      }

      get deleteDelay () {
        return this.dataset.deleteDelay
      }

      get nextWordDelay () {
        return this.dataset.nextWordDelay
      }
    },
  )
}
